import React from "react";
import Icon from "@ant-design/icons";

const DeleteIcon = ({
  width = "16",
  height = "16",
  className = "",
  style = {},
}) => (
  <span role="img" className={`anticon ${className}`} style={style}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 5.602c0 3.5.8 8 .8 8h6.4s.8-4.5.8-8"
      ></path>
      <path stroke="currentColor" strokeLinecap="round" d="M2.4 4h11.2"></path>
      <path
        stroke="currentColor"
        d="M5.6 3.998v-1.1a.5.5 0 01.5-.5h3.8a.5.5 0 01.5.5v1.1"
      ></path>
    </svg>
  </span>
);

const DeleteV3Icon = ({
  width = "16",
  height = "16",
  className = "",
  style = {},
}) => (
  <span role="img" className={`anticon ${className}`} style={style}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="currentColor"
        d="M5.6 3.6V2.5a.5.5 0 01.5-.5h3.8a.5.5 0 01.5.5v1.1"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4 3.6a.4.4 0 000 .8h1.202c.023 2.02.212 4.254.4 6.017.1.941.2 1.751.276 2.325.037.287.069.516.09.673.011.078.02.139.026.18l.007.047.002.016c0 0 0 0 .4-.058l-.4.058c.029.196.198.342.396.342h6.4a.4.4 0 00.396-.342l-.396-.058c.396.058.396.058.396.058l.002-.016.007-.047c.006-.041.014-.102.02-.18.022-.157.054-.386.09-.673.076-.574.176-1.384.276-2.325.188-1.763.377-3.998.4-6.017h1.202a.4.4 0 000-.8H2.4zm2.002 .8c.023 1.98.209 4.181.396 5.933.1.934.2 1.737.274 2.306.03.226.056.416.076.561h5.706c.02-.145.046-.335.076-.561.075-.569.174-1.372.274-2.306.187-1.752.373-3.953.396-5.933H4.402z"
      ></path>
      <path
        fill="currentColor"
        d="M4.402 4.4c.023 1.98.211 4.181.398 5.933.1.934.2 1.737.274 2.306.03.226.056.416.076.561h5.706c.02-.145.046-.335.076-.561.075-.569.174-1.372.274-2.306.187-1.752.373-3.953.396-5.933H4.402z"
      ></path>
    </svg>
  </span>
);

export { DeleteIcon, DeleteV3Icon };